module.exports = __webpack_public_path__ + "img/hero@2x.7201a794.png";